export default class FileUpload {
  constructor(opts) {
    this.onComplete = opts.onComplete
    this.onError = opts.onError
    this.uploadUrl = opts.uploadUrl
    this.uploadScope = opts.uploadScope;
  }

  perform(file){
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (eve) => {
      let form = new N2Styles.manualForm()
      form.setRootParam('base64_file')
      form.form.attr('method', 'post');
      form.setUrl(this.uploadUrl)
      form.addInput('file_name', file.name.replace(/ /g,'_'));
      form.addInput('asset_base64', eve.target.result);
      form.addInput("scope", this.uploadScope);

      form.sync({
        success: (resp) => {
          this.onComplete(resp, file)
        },
        error: (req, status) => {
          this.onError(req.responseJSON, file)
        },
        context: this
      })
    }
  }
}
